import { graphql, useStaticQuery } from "gatsby"
import { reduceMicrocopySet } from "./reduceMicrocopy"
import "../fragments/Page"

export default function useSocialMedia() {
  const { microcopySet } = useStaticQuery(graphql`
    query {
      microcopySet: contentfulMicrocopySet(contentful_id: { eq: "6aTWRYGqhRlchDkU2GdUsV" }) {
        ...microcopySet
      }
    }
  `)

  const labels = reduceMicrocopySet(microcopySet) || {}

  return {
    twitter: labels["socialMedia:twitter"],
    facebook: labels["socialMedia:facebook"],
    linkedin: labels["socialMedia:linkedin"],
    youtube: labels["socialMedia:youtube"],
  }
}
